import DefaultUnitHtml from './templates/unit.default.html';

export function DefaultUnits () {
  return {
    //controller: 'VehicleInvoicesCtrl',
    restrict: 'E',
    templateUrl: DefaultUnitHtml
  }
}